import { Button } from "@design";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import type { ApiKeyCreatedResponse } from "@/api";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { CopyValue } from "@/components/CopyValue";
import { InlineNotice } from "@/components/InlineNotice";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { Text } from "@/components/Text";
import { NewApiKeyForm } from "./NewApiKeyForm";

function CreatedKey({ created, onDone }: Readonly<{ created: ApiKeyCreatedResponse; onDone: () => void }>) {
  const { t } = useTranslation("settings");
  return (
    <div className="flex flex-col gap-5">
      <Text variant="h3">{t("security.created.title", { name: created.name })}</Text>
      <InlineNotice tone="warning">{t("security.created.body")}</InlineNotice>
      <CopyValue value={created.key} label={t("security.created.keyLabel")} secret />
      <div>
        <Button variant="primary" onClick={onDone}>
          {t("security.created.done")}
        </Button>
      </div>
    </div>
  );
}

export function NewApiKeyPage() {
  const { t } = useTranslation("settings");
  const areas = useAreaCrumbs();
  const navigate = useNavigate();
  const [created, setCreated] = useState<ApiKeyCreatedResponse | null>(null);
  const back = () => navigate("/settings/security");
  return (
    <div className="flex flex-col">
      <PageBreadcrumbs
        trail={[areas.settings, { label: t("security.title"), to: "/settings/security" }]}
        current={t("security.keys.new")}
      />
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-6 md:px-8">
        {created ? <CreatedKey created={created} onDone={back} /> : <NewApiKeyForm onCreated={setCreated} />}
      </div>
    </div>
  );
}
